import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  root: {},
  conditions: {
    padding: "12px 16px 0 16px",
    [theme.breakpoints.up("md")]: {
      padding: "12px 24px 0px 24px",
    },
  },
  actions: {
    padding: "0 16px 16px 16px",
    [theme.breakpoints.up("md")]: {
      padding: "0 24px 24px 24px",
    },
  },
  divider: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    height: 42,
    padding: "0 16px",
    background: theme.palette.grey[50],
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    "&::before": {
      content: "''",
      position: "absolute",
      top: "50%",
      right: 16,
      left: 48,
      borderTop: `1px dashed ${theme.palette.grey[300]}`,
    },
    [theme.breakpoints.up("md")]: {
      height: 58,
      padding: "0 24px",
    },
  },
}));
